import { memo } from 'react';

import { useVideoProgress } from '@web/molecules/VideoPlayer/hooks/useVideoProgress';
import styles from '@web/organisms/VideoCarousel/atoms/ProgressBar/ProgressBar.module.scss';

export interface Props {
    videoID: string;
    isActive: boolean;
}

export const Component = ({ videoID, isActive }: Props) => {
    const [progress, _setProgress] = useVideoProgress(videoID, 0);
    const classes = [styles.ProgressBar];
    if (isActive) classes.push(styles[`active`]);

    return (
        <div className={classes.join(' ')}>
            <span className={styles.bar} style={{ width: `${progress}%` }} />
        </div>
    );
};

export const ProgressBar = memo(Component);
